import { v4 as uuidv4 } from 'uuid';

import { isUuidV4 } from 'functions/isUuidV4';

import { KnmHistoryOperationsEnum } from '../../../../APIPackage/KnmModule/enums/KnmHistoryOperationsEnum';
import { formatDate } from '../../../../CorePackage/MainModule/common/formatDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../../CorePackage/MainModule/constants/dateFormats';
import { KNM_HISTORY_FIELD_TEXT_PREFIX } from '../../../KnmHistoriesModule/constants/knmHistoryFieldTextPrefix';
import { knmHistoryFieldOperationsMap } from '../../../KnmHistoriesModule/constants/knmHistoryFieldOperationsMap';
import { IKnmHistoryItem } from '../../../../APIPackage/KnmModule/interfaces/IKnmHistoryItem';

export function getLateFiledText(lateChangesFields: IKnmHistoryItem[], fieldName: string) {
  if (
    !lateChangesFields
      .flatMap(x => x?.changes)
      ?.find(x => x?.field.includes(fieldName) && x.operation !== KnmHistoryOperationsEnum.DELETE)
  ) {
    return null;
  }

  return (
    <>
      <div style={{ fontWeight: 800 }}>Cведения внесены не своевременно</div>

      {lateChangesFields.map(lateChange => {
        const changesList = lateChange.changes.filter(
          change =>
            change.field.includes(fieldName) &&
            change.operation !== KnmHistoryOperationsEnum.DELETE &&
            (Array.isArray(change.newValue) ||
              typeof change.newValue === 'string' ||
              typeof change.newValue === 'boolean' ||
              typeof change.newValue === 'number') &&
            !isUuidV4(change.newValue),
        );

        const key = uuidv4();

        if (changesList?.length) {
          return (
            <div key={key}>
              <div>
                {`${lateChange.user?.fullName} (${lateChange.user?.username}) ${formatDate({
                  date: lateChange.utcTimestamp,
                  dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                  parseFormat: DATE_FORMAT_ISO_FNS,
                })} (МСК)`}
              </div>
              {changesList.map(change => {
                let valuesText = '';

                if (change.operation === KnmHistoryOperationsEnum.INSERT) {
                  valuesText = `"${change.newValue}"`;
                } else if (change.operation === KnmHistoryOperationsEnum.UPDATE) {
                  valuesText = `${change.oldValue ? `с "${change.oldValue}" ` : ''}на "${change.newValue}"`;
                }

                const changeKey = uuidv4();

                return (
                  <div key={changeKey}>
                    {`${KNM_HISTORY_FIELD_TEXT_PREFIX} ${
                      knmHistoryFieldOperationsMap[change.operation]
                    } ${valuesText.replace('"false"', '"Нет"').replace('"true"', '"Да"')}`}
                  </div>
                );
              })}
            </div>
          );
        }

        return null;
      })}
    </>
  );
}
